import { useEffect, useRef } from "react";
import { ACCENT } from "../shared/landingTheme";
import { iniciarHeroAoVivo } from "./motorHeroAoVivo";

// "#4ADF83" -> [74, 223, 131]: o motor do canvas trabalha com rgba().
const ACCENT_RGB = ACCENT.match(/\w\w/g).map((h) => parseInt(h, 16));

/*
 * Coluna direita do HERO: a animação "do celular ao ar" (ver motorHeroAoVivo.js).
 *
 * A caixa tem o formato vertical 9:16 e acompanha a altura do bloco do
 * título. O canvas é MAIOR que a caixa (inset negativo) para os brilhos
 * vazarem sem corte — a página já tem `overflowX: hidden`
 * (PAGINA_PUBLICA_STYLE), então isso não cria rolagem lateral.
 *
 * Vai como <style> porque a troca de layout no celular depende de media
 * query, que estilo inline não alcança (mesmo motivo de VitrineEstilos).
 */
export default function HeroAoVivo() {
  const canvasRef = useRef(null);

  useEffect(() => {
    let parar = () => {};
    let desmontado = false;
    // Espera a Inter carregar: o canvas não redesenha texto quando a fonte chega.
    const pronto = document.fonts?.ready ?? Promise.resolve();
    pronto.then(() => {
      if (desmontado || !canvasRef.current) return;
      parar = iniciarHeroAoVivo(canvasRef.current, { accent: ACCENT_RGB });
    });
    return () => {
      desmontado = true;
      parar();
    };
  }, []);

  return (
    <>
      <style>{`
        .hero-ao-vivo {
          position: relative;
          aspect-ratio: 9 / 16;
          justify-self: center;
          height: min(78vh, 700px);
          max-width: 100%;
          perspective: 1400px;
        }
        .hero-ao-vivo canvas {
          position: absolute;
          inset: -14% -22%;
          width: 144%;
          height: 128%;
          display: block;
          transform-style: preserve-3d;
          will-change: transform;
          pointer-events: none;
        }
        @media (max-width: 1000px) {
          .hero-grid { grid-template-columns: 1fr !important; }
          .hero-ao-vivo { height: auto; width: min(78vw, 360px); margin-top: 2rem; }
        }
      `}</style>
      <div className="hero-ao-vivo" aria-hidden="true">
        <canvas ref={canvasRef} />
      </div>
    </>
  );
}
